import { StoredProcedureScope } from '@cloud-native/workflows-engine'
import { FeatureFlag, useFeatureFlag } from 'app/ui/useFeatureFlag'
import { Workflow, WorkflowListItem } from 'features/workflows/types'
import { getMcpToolVariables } from './variables'
import { formatWorkflowUrl } from './formatCodeSnippets'
import { isProcedureOutdated } from '../service/common/utils'

export function useMcpToolEnabled(workflow: Workflow | WorkflowListItem) {
  const isFeatureFlagEnabled = useFeatureFlag(FeatureFlag.McpServerUrlV1)
  const isProcedureCreated = Boolean(workflow?.config?.mcpTool?.procedure?.call)
  return isFeatureFlagEnabled && isProcedureCreated
}

export function isMcpToolOutdated(workflow: Workflow) {
  const mcpTool = workflow?.config?.mcpTool
  const mcpToolDraft = mcpTool?.draft
  const isEnabled = !!mcpTool?.enabled
  const isNameOutdated = mcpTool?.name !== workflow?.config?.title
  const isDescriptionOutdated = mcpTool?.description !== mcpToolDraft?.description
  const isOutputOutdated = mcpTool?.output?.description !== mcpToolDraft?.output?.description
  const isInputsOutdated = (mcpTool?.inputs || []).some(
    (input) => input.description !== mcpToolDraft?.inputs?.[input.name]?.description
  )
  return (
    isEnabled &&
    (isProcedureOutdated(workflow, StoredProcedureScope.McpTool) ||
      isNameOutdated ||
      isDescriptionOutdated ||
      isOutputOutdated ||
      isInputsOutdated)
  )
}

export function isMcpToolFormValid(workflow: Workflow) {
  return (
    Boolean(workflow?.config.mcpTool.draft?.description?.trim()) &&
    Boolean(workflow?.config.mcpTool.draft?.output?.description?.trim()) &&
    getMcpToolVariables(workflow?.config.variables).every((variable) =>
      Boolean(workflow?.config.mcpTool.draft?.inputs?.[variable.name]?.description?.trim())
    )
  )
}

export function generateMcpServerPayload(workflow: Workflow, isWorkflowSync: boolean) {
  return {
    method: 'POST',
    endpoint: formatWorkflowUrl(workflow, isWorkflowSync),
    payload: {
      query: workflow.config.mcpTool.procedure?.call ?? '',
      queryParams: JSON.parse(workflow.config.mcpTool.procedure?.params ?? '{}')
    }
  }
}
